import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import {
	LogoutPayload,
	ResponsibleGamingConfigService,
	SESSION_ACTION_TYPE,
	SessionSummaryAction,
	SessionSummarySelector,
} from "@obg/ngx.core";
import { filter, map, switchMap, withLatestFrom } from "rxjs/operators";

import { CommonState } from "../state";

import { NotificationService } from "./notification.service";

@Injectable()
export class NotificationEffect {
	successfulLogoutMessage$ = createEffect(() =>
		this.actions$.pipe(
			ofType(SESSION_ACTION_TYPE.logoutSuccess),
			map((action?: ActionWithPayload<LogoutPayload>) => action?.payload),
			filter((logoutPayload) => !logoutPayload?.shouldSkipNotification),
			withLatestFrom(
				this.store.select(SessionSummarySelector.get),
				this.responsibleGamingConfigService.getSessionSummaryEnabled$()
			),
			switchMap(([, sessionSummary, sessionSummaryEnabled]) =>
				this.service.openLogoutSnackbar$(sessionSummary, sessionSummaryEnabled)
			),
			map(() => SessionSummaryAction.clear())
		)
	);

	constructor(
		private actions$: Actions,
		private store: Store<CommonState>,
		private responsibleGamingConfigService: ResponsibleGamingConfigService,
		private service: NotificationService
	) {}
}
